import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Dropdown, MenuItem } from 'react-bootstrap';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SigtripStaffsTrainings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/treinamentos/associados', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'redirect') {
            var url = '/sigmec/treinamentos/';
            self.setState({redirect_url: url});
        } else {
            self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/relatorio/voo/editar/' + cell;

    var botao = (
      <Dropdown id="export-data">
        <Dropdown.Toggle bsStyle={'primary'}>
          <i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.Exportar}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem onSelect={this.export} eventKey={('/exportar/comunicado/treinamento/solo/'+row.id)}>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.Solo}</MenuItem>
          <MenuItem onSelect={this.export} eventKey={('/exportar/comunicado/treinamento/solo-tic/'+row.id)}>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.SoloTIC}</MenuItem>
          <MenuItem onSelect={this.export} eventKey={('/exportar/comunicado/treinamento/simulador/'+row.id)}>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.Simulador}</MenuItem>
          <MenuItem onSelect={this.export} eventKey={('/exportar/comunicado/treinamento/ead/'+row.id)}>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.EAD}</MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );

    return botao;
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  render() {
    return (
<div>
    {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title">{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.semTreinamentos, defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Nome}</TableHeaderColumn>

        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Status}</TableHeaderColumn>

        <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.CodigoDeControle}</TableHeaderColumn>


        <TableHeaderColumn dataField="certification_types" dataAlign="center" filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.CertificationsTypesTable} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.TiposDeCertificado}</TableHeaderColumn>

        <TableHeaderColumn dataField="presence_types" dataAlign="center" filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.PresenceTypesTable}>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Modalidade}</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.DataInicial}</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.DataFinal}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default SigtripStaffsTrainings;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/SigtripStaffsTrainings.js